import { Container } from 'pixi.js';
import type { Scene } from '../app/SceneManager';
import { soundManager, SoundTrackId } from '../app/SoundManager';
import { MainMenuController } from './MainMenuController';
import type { App } from '../app/App';
import type { DioramaView } from '../game/views/dioramas/DioramaView';
import { GameSceneMVC } from '../game/scene/GameSceneMVC';

export class MainMenuScene implements Scene {
  public readonly id = 'MainMenu';

  public view: Container = new Container();

  private readonly mainMenuController: MainMenuController;

  private readonly closeMenu: () => void;

  constructor(
    private readonly app: App,
    dioramaView?: DioramaView,
  ) {
    const { overlay } = app.controller;
    const { stateController } = app;
    const { sceneManager } = app.controller;

    const goToNextLevel = (): void => {
      const { currentLevelData: levelData } = stateController;
      const gameScene = new GameSceneMVC({
        app,
        levelData,
        saveProgress: true,
      });
      sceneManager.activateScene(gameScene);
    };

    const restartScene = (): void => {
      sceneManager.activateScene(new MainMenuScene(app));
    };

    this.mainMenuController = new MainMenuController({
      app: this.app,
      root: overlay.view,
      goToNextLevel,
      restartScene,
    });
    const { closeMenu } = this.mainMenuController.openMainMenu(dioramaView);
    this.closeMenu = closeMenu;

    soundManager.playLoop(SoundTrackId.Music, 'Gameplay_Music', 100);

    this.view.once('added', () => {
      this.onAddedToStage();
    });
  }

  public resize(width: number, height: number): void {
    this.mainMenuController.mainMenuView?.resize(width, height);
  }

  public destroy(): void {
    this.closeMenu();
    this.view.destroy({ children: true });
  }

  private onAddedToStage(): void {
    // Check bot subscribe on returning to main-menu.
    void this.app.platform.checkBotSubscription(250);
  }
}
